import apiClient from './apiClient';

function errorMessage(error) {
  const data = error.response?.data;
  if (data?.errors?.length) return data.errors.join(', ');
  if (data?.error) return data.error;
  return error.message || 'Request failed';
}

class JiraAccountService {
  async getAccounts() {
    try {
      const response = await apiClient.get('/jira_accounts');
      return response;
    } catch (error) {
      throw new Error(errorMessage(error));
    }
  }

  async createAccount(accountData) {
    try {
      return await apiClient.post('/jira_accounts', { jira_account: accountData });
    } catch (error) {
      throw new Error(errorMessage(error));
    }
  }

  async updateAccount(accountId, accountData) {
    try {
      return await apiClient.patch(`/jira_accounts/${accountId}`, { jira_account: accountData });
    } catch (error) {
      throw new Error(errorMessage(error));
    }
  }

  async activateAccount(accountId) {
    try {
      return await apiClient.patch(`/jira_accounts/${accountId}/activate`);
    } catch (error) {
      throw new Error(errorMessage(error));
    }
  }

  async deleteAccount(accountId) {
    try {
      await apiClient.delete(`/jira_accounts/${accountId}`);
    } catch (error) {
      throw new Error(errorMessage(error));
    }
  }

  async testConnection(accountId) {
    return await apiClient.post(`/jira_accounts/${accountId}/test_connection`);
  }
}

export const jiraAccountService = new JiraAccountService();
